module.exports = __webpack_public_path__ + "img/2.9f1bd331.png";